import React from 'react';
import propTypes from 'prop-types';
import './home.css';
import { pos } from '../../config/constant'
import {
  updateCurrentLayout
} from '../../action/action';
import { connect } from 'react-redux';
import UserInfo from './user-info/userInfo'
import UserAcivity from './user-activities/userActivity'
import PromoWidget from './promo-widget/promoWidget'
import UserShortcut from './user-shortcut/userShortcut'
import { heightFixer } from '../../JS/heightFix'
import { setColor } from '../../JS/setColors'
/*import {
  getCurrentSchedule,
  getLayout
} from '../shared/layoutSelector'
import { languageSelector } from '../shared/languageSelector'
*/
class home extends React.Component {
  /*constructor(props) {
    super(props);
    this.state = {
      currentLayout: {},
      currentLang: ""
    }

  static getDerivedStateFromProps(props, state) {
    let currentLayout, schedule, curLangStr;
    console.log("get drive states", state.currentLang, props.guestLanguages);
    curLangStr = languageSelector(props);
    schedule = getCurrentSchedule(props);
    currentLayout = getLayout(props, schedule);
    console.log("home call currentLayout",currentLayout);
    if (currentLayout &&
      props.durationId !== currentLayout.durationId) {
      props.updateCurrentLayout(currentLayout, currentLayout.durationId, curLangStr);
    }
    return {
      currentLayout,
      currentLang: props.guestLanguages
    }
  }
*/
  //this function will map widget to its position given by hotel
  setCompToPositions = (forPosition) => {
    let position;
    return pos.map((i) => {
      position = parseInt(i.position)
      if (position === forPosition) {
        switch (i.widgetName) {
          case "userInfo":
            return <UserInfo />
          // case "userActivity":
          //   return <UserAcivity />
          case "promo":
            return <PromoWidget />
          case "userShortcut":
            return <UserShortcut />
          default:
          //console.log("this is not a widget");
        }
      }
    })
  }
  componentDidUpdate() {
    //setColor(this.props.menuColor);
  }

  componentDidMount() {
    setColor(this.props.menuColor);
  }

  render() {
    //console.log("device",window.device);
    //console.log("current Layout", this.state.currentLayout, this.props.durationId);
    return (
      <div id="home" className="contentSection h-100 center-v">
        {
          //This is old className of home. Updated this after WKWebView.(7/2/20) 
          // className={
          //   window.device && window.device.platform === "iOS" ?
          //     "contentSection1 h-100 center-v" : "contentSection h-100 center-v"}

        }
        <div className="columns"
        >
          {/*
          style={{
            height: "48%",
            minHeight: "390px",
            marginBottom: "25px"
          }}
        */}
          {this.setCompToPositions(1)}

          {this.setCompToPositions(3)}

        </div>
        {/*right column in Home page*/}
        <div className="columns">

          {this.setCompToPositions(2)}


          {this.setCompToPositions(4)}

        </div>
      </div>
    )
  }
}

//export default home
/*
const mapStateToProps = state => {
  return {
    clientConfig: state.store.home.clientConfig.deviceWidgetsInfo,
    //
    schedules: state.store.home.clientConfig.deviceWidgetsInfo ?
      state.store.home.clientConfig.deviceWidgetsInfo.schedules : {},
    //
    durations: state.store.home.clientConfig.deviceWidgetsInfo ?
      state.store.home.clientConfig.deviceWidgetsInfo.durations : [],
    //
    defaultLayouts: state.store.home.clientConfig.deviceWidgetsInfo ?
      state.store.home.clientConfig.deviceWidgetsInfo.defaultLayout : {},
    //server time
    serverTime: state.store.home.serverTimeDate.payload ?
      state.store.home.serverTimeDate.payload.time : {},
    //
    guestLanguages: state.store.home.guestLanguage ?
      state.store.home.guestLanguage.preferredLanguageCode : "",
    //
    hotelLanguage: state.store.home.hotelLanguages.payload ?
      state.store.home.hotelLanguages.payload : {},
    //
    durationId: state.store.home.durationId
  }
}

home.propTypes = {
  serverTime: propTypes.object,
  schedules: propTypes.object,
  durations: propTypes.arrayOf(propTypes.object),
  defaultLayouts: propTypes.object,
  guestLanguages: propTypes.String,
  hotelLanguage: propTypes.object,
  durationId: propTypes.bool
}
*/
const mapStateToProps = state => {
  return {
    menuColor: state.store.home.MenuColor,
  }
}
export default connect(
  mapStateToProps,
  {
    updateCurrentLayout
  }
)(home);